import React from 'react'
import owner from "../../img/raju-pic.jpg";
import a from "../../img/a10.jpg";
import b from "../../img/a9.jpg";
import c from "../../img/a11.jpg";
import d from "../../img/a12.jpg";
import '../owner/Owner.css';
import { Link } from 'react-router-dom';

function Owner() {
  return (
    <>
      <div class="container my-5">
        <h1 className="fw-bold mb-5 text-center" style={{ color: '#cf6511' }}>Our Services</h1>
        <div class="row g-4">
          <div class="col-md-3 col-12">
            <div class="card card-custom">
              <Link to="/services">
              <img src={a} class="card-img" alt="Conference Halls" style={{ height: '400px' }} />
              <div class="card-img-overlay">
                <h5 class="card-title text-white">Wedding Catering</h5>
              </div>
              </Link>
            </div>
          </div>

          <div className="col-md-3 col-12">
            <div className="card card-custom">
              <Link to="/services">
                <img src={b} className="card-img" alt="Baby Showers" style={{ height: "400px" }} />
                <div className="card-img-overlay">
                  <h5 className="card-title text-white">Baby Showers</h5>
                </div>
              </Link>
            </div>
          </div>

          <div class="col-md-3 col-12">
            <div class="card card-custom">
              <Link to="/services">
              <img src={c} class="card-img" alt="Auditorium" style={{ height: '400px' }} />
              <div class="card-img-overlay">
                <h5 class="card-title text-white">Religious Catering</h5>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-md-3 col-12">
            <div class="card card-custom">
              <Link to="/services">
              <img src={d} class="card-img" alt="Auditorium" style={{ height: '400px' }} />
              <div class="card-img-overlay">
                <h5 class="card-title text-white">Birthday Parties</h5>
              </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section className="about-us py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <h5 className=" fw-bold" style={{ color: '#cf6511' }}>Our Owner</h5>
              <h2 className="fw-bold mb-3">Catering since 1998</h2>
              <p>
                Founded in 1998, Raju Caterer has become one of the most sought after catering companies in Bangalore and surroundings.
              </p>
              <p>
                The company is based in Bangalore and offers delicious food and mind-blowing presentation for your every occasion such as wedding, reception, cocktail, birthday, intimate gatherings and corporate events.
              </p>
              <p>
                At each of our organized event, we make sure everything matches your taste because it is your big day and we love to make it memorable for you. Offering a delightful menu within the budget of one and all, we make every occasion a unique celebration with our supreme standard foodstuff.
              </p>
              {/* <a href="#" class="btn  fw-bolder px-4">Read More</a> */}
            </div>
            <div className="col-lg-5 mb-lg-0">
              <img src={owner} alt="About Us" className="img-fluid rounded shadow" />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Owner
